export default [
	{
		path: "/extra/release/approval_list/:approval_id/:type",
		name: "release_approval_list",
		component: () => import("@/views/release/approval_list"),
		hidden: true,
		meta: {
			title: '放行審批'
		}
	},
	{
		path: "/extra/release/approval_history/:approval_id/:cph",
		name: "release_approval_history",
		component: () => import("@/views/release/approval_history"),
		hidden: true,
		meta: {
			title: '放行審批歷史記錄'
		}
	},
	{
		path: "/extra/release/approval_result/:result_id/:type",
		name: "release_approval_result",
		component: () => import("@/views/release/approval_result"),
		hidden: true,
		meta: {
			title: '放行審批結果通知'
		}
	}
]